import { merge } from 'lodash-es';

export type MeasurementFormat = 'MiKm' | 'FtM' | 'MilesKilometers';

export class FormattedValue {
    readonly rawUnits: string | string[] = '';
    readonly rawValue: string | string[] = '';

    constructor(
        data: {
            units?: string | string[];
            value?: string | string[];
        } = {}
    ) {
        merge(this, {
            rawUnits: data.units,
            rawValue: data.value,
        });
    }

    get invalid(): boolean {
        return !this.isValid;
    }

    get isArray(): boolean {
        return Array.isArray(this.rawValue);
    }

    get isValid(): boolean {
        return typeof this.value === 'string' && this.value.length > 0;
    }

    get units(): string {
        return Array.isArray(this.rawUnits) ? this.rawUnits[0] : this.rawUnits;
    }

    get units2(): string {
        return Array.isArray(this.rawUnits) ? this.rawUnits[1] : '';
    }

    get value(): string {
        return Array.isArray(this.rawValue) ? this.rawValue[0] : this.rawValue;
    }

    get value2(): string {
        return Array.isArray(this.rawValue) ? this.rawValue[1] : '';
    }
}
